import {
  getJobLevelList,
  editStaff
} from '@/api/staff'
import Message from 'ant-design-vue/lib/message'
import 'ant-design-vue/lib/message/style'
const staff = {
  state: {
    jobLevelList: [],
    staff: []
  },
  mutations: {
    GET_JOB_LEVEL_LIST: (state, jobLevelList) => {
      state.jobLevelList = jobLevelList
    },
    GET_STAFF_INFO: (state, staff) => {
      state.staff = staff
    }
  },
  actions: {
    getJobLevelList ({
      commit
    }, payload) {
      return new Promise((resolve, reject) => {
        getJobLevelList(payload).then(res => {
          if (res.data.code < 0) {
            setTimeout(() => {
              Message.error(res.data.msg, 0.5)
            }, 500)
          } else {
            const allType = { text: '全部', level: '' }
            const params = res.data.data
            params.unshift(allType)
            commit('GET_JOB_LEVEL_LIST', params)
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    editStaff ({
      commit
    }, payload) {
      return new Promise((resolve, reject) => {
        editStaff(payload).then(res => {
          commit('GET_JOB_LEVEL_LIST', res.data.data)
          if (res.data.code < 0) {
            Message.error(res.data.msg, 0.5)
          } else {
            if (payload.type !== 'list') {
              Message.success(res.data.msg, 0.5)
            }
          }
          resolve(res)
          return res
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default staff
